import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const upwork = defineConnector({
  identifier: "upwork",
  name: "Upwork",
  tagLine: "Freelance talent marketplace",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://api\\.upwork\\.com/.*|https://www\\.upwork\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API application",
      items: [
        {
          kind: "markdown",
          content:
            "Register an application at [Upwork Developers](https://www.upwork.com/developer/documentation) to get your OAuth 2.0 credentials.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "markdown",
          content:
            "Complete the OAuth 2.0 authorization flow to obtain an access token. See the [API docs](https://www.upwork.com/developer/documentation) for details.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.upwork.com/graphql",
      method: "POST" as const,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ user { id } }" }),
    }),
  },
});
